module.exports = __webpack_public_path__ + "img/bg-szg-download.c73ca11f.png";